import React, { useState } from "react";
import axios from "axios";
import "./App.css";

const App = () => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_KEY = "8dc33a85b5mshac16f04d96f14bbp113ad3jsn3a412d644f7e";
  const API_HOST = "chatgpt-42.p.rapidapi.com";

  const getChatGPTResponse = async (message) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `https://${API_HOST}/conversationgpt4-2`,
        {
          messages: [
            {
              role: "user",
              content: message,
            },
          ],
          system_prompt: "",
          temperature: 0.9,
          top_k: 5,
          top_p: 0.9,
          max_tokens: 256,
          web_access: false,
        },
        {
          headers: {
            "x-rapidapi-key": API_KEY,
            "x-rapidapi-host": API_HOST,
            "Content-Type": "application/json",
          },
        }
      );

      const newMessage = { role: "user", content: message };
      let responseContent = response.data.result || "No response from API";

      const formattedResponse = responseContent
        .split("\n")
        .filter((point) => point.trim())
        .map((point) => `<li>${point.trim()}</li>`)
        .join("");

      const newResponse = {
        role: "assistant",
        content: `<ul>${formattedResponse}</ul>`,
      };

      setMessages([...messages, newMessage, newResponse]);
    } catch (error) {
      console.error("Error fetching data from ChatGPT API:", error);
      setMessages([
        ...messages,
        { role: "user", content: message },
        {
          role: "assistant",
          content: "Error occurred while fetching response.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };
  const createMarkup = (content) => {
    return { __html: content };
  };

  const handleSend = () => {
    if (input.trim()) {
      getChatGPTResponse(input);
      setInput("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent new line
      handleSend(); // Trigger the send function
    }
  };

  return (
    <div className="App">
      <div className="background-video">
        <video className="videoTag" autoPlay loop muted>
          <source
            src="https://videos.pexels.com/video-files/854322/854322-hd_1280_720_25fps.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="chat-container" style={{ marginLeft: 8, marginRight: 8 }}>
        <p
          style={{
            fontWeight: "bold",
            fontSize: 20,
            textAlign: "center",
            fontFamily: "cursive",
            height: 8,
            marginTop: "-2px",
          }}
        >
          Chat With Me
        </p>
        <div className="chat-history">
          {messages.map((msg, index) => (
            <div key={index} className={`message ${msg.role}`}>
              <p dangerouslySetInnerHTML={createMarkup(msg.content)} />
            </div>
          ))}
        </div>
        <div className="chat-input">
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message here..."
            onKeyDown={handleKeyDown}
          />
          <button onClick={handleSend} disabled={loading}>
            {loading ? (
              <img
                src="/icon/loader.svg"
                alt="Loading..."
                style={{ width: 15, height: 15 }}
                className="spinner"
              />
            ) : (
              "Send"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default App;
